export default __webpack_public_path__ + "static/media/eye-slash.914782b2.svg";